function bindSizeChartPopup() {
  const popup = document.getElementById('sizeChartPopup');
  if (!popup) return; // Popup HTML nathi to script exit

  const popupBody = document.getElementById('popup-body');
  const closeBtn = popup.querySelector('.close-popup');

  // Attach click event to all size-chart links
  document.querySelectorAll('.size-chart-link').forEach(btn => {
    btn.addEventListener('click', function () {
      // Get dataset value safely
      let collection = this.dataset.collection || '';
      collection = collection.toLowerCase().trim();
      console.log('Detected collection:', collection);

      let content = '';

      // Detect T-shirt related collections
      const isTshirt =
        collection.includes('tshirt') ||
        collection.includes('t-shirt') ||
        collection.includes('t shirt');

      // Detect Shirt related collections (but exclude tshirt)
      const isShirt =
        collection.includes('shirt') && !isTshirt;

      if (isShirt) {
        const shirtChart = document.getElementById('shirt-chart');
        content = shirtChart ? shirtChart.innerHTML : '<p>Shirt size chart missing.</p>';
      } else if (isTshirt) {
        const tshirtChart = document.getElementById('tshirt-chart');
        content = tshirtChart ? tshirtChart.innerHTML : '<p>T-shirt size chart missing.</p>';
      } else {
        content = '<p>No size chart available.</p>';
      }

      popupBody.innerHTML = content;
      popup.style.display = 'block';
    });
  });

  // Close popup on close button
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      popup.style.display = 'none';
    });
  }

  // Close popup on outside click
  window.addEventListener('click', e => {
    if (e.target === popup) {
      popup.style.display = 'none';
    }
  });
}

// Bind on initial load and when Horizon re-renders sections
document.addEventListener('DOMContentLoaded', bindSizeChartPopup);
document.addEventListener('shopify:section:load', bindSizeChartPopup);